import React, { Component } from "react";
import { Button } from "react-bootstrap";
import "../../../../assets/css/template.css";

class ButtonRenderer extends Component {
  redirect = () => {
    const { data = {} } = this.props || {};
    const { vendorProfileId, onboardingPhase = "", nextSteps = "", duns } =
      data || {};
    localStorage.setItem("vid", vendorProfileId);
    localStorage.setItem("duns", duns);

    switch (onboardingPhase) {
      case "Company Details":
        if (nextSteps === "Company Details") {
          window.location = `/boarding/vendor/company/${vendorProfileId}`;
        } else if (nextSteps === "Address Details") {
          window.location = `/boarding/vendor/address/${vendorProfileId}`;
        } else if (nextSteps === "Contact Details") {
          window.location = `/boarding/vendor/contact/${vendorProfileId}`;
        } else if (nextSteps === "Merchant Approval") {
          window.location = `/boarding/merchant/${vendorProfileId}`;
        }
        break;
      case "Pre-Boarding":
        if (nextSteps === "Upload Documents") {
          window.location = `/boarding/vendor/documentCenter`;
        } else if (nextSteps === "Upload Contract") {
          window.location = `/boarding/ops/11/${vendorProfileId}`;
        } else if (nextSteps === "Update Vendor Profile") {
          window.location = `/boarding/vendor/vendor-profile/${vendorProfileId}`;
        } else if (nextSteps === "Setup Dvn") {
          window.location = `/boarding/vendor/dvnsetup/`;
        } else if (nextSteps === "Ups Account") {
          window.location = `/boarding/ops/17/${vendorProfileId}`;
        } else if (nextSteps === "Dvn Audit") {
          window.location = `/boarding/vendor/dvnaudit/${vendorProfileId}`;
        }
        break;
      case "Integration":
        if (nextSteps === "Upload Packing Slip") {
          window.location = `/boarding/ops/10/${vendorProfileId}`;
        } else if (nextSteps === "Upload Shipping Label") {
          window.location = `/boarding/ops/1/${vendorProfileId}`;
        } else if (nextSteps === "Order Testing") {
          window.location = `/boarding/ops/2/${vendorProfileId}`;
        } else if (nextSteps === "846 Testing") {
          window.location = `/boarding/ops/3/${vendorProfileId}`;
        } else if (nextSteps === "Boss Agreement") {
          window.location = `/boarding/ops/4/${vendorProfileId}`;
        } else if (nextSteps === "Table Setup") {
          window.location = `/boarding/ops/13/${vendorProfileId}`;
        } else if (nextSteps === "Quality Leader Approval") {
          window.location = `/boarding/ops/14/${vendorProfileId}`;
        } else if (nextSteps === "EVP and ERP Setup") {
          window.location = `/boarding/ops/15/${vendorProfileId}`;
        } else if (nextSteps === "Item / SKU Setup") {
          window.location = `/boarding/ops/16/${vendorProfileId}`;
        }
        break;
      case "Publish":
        if (nextSteps === "Vendor Line List") {
          window.location = `/boarding/ops/5/${vendorProfileId}`;
        } else if (nextSteps === "Page Complete") {
          window.location = `/boarding/ops/6/${vendorProfileId}`;
        } else if (nextSteps === "Onboarding Complete") {
          window.location = `/boarding/ops/12/${vendorProfileId}`;
        } else if (nextSteps === "Live") {
          window.location = `/boarding/ops/7/${vendorProfileId}`;
        }
        break;
      default:
        break;
    }
  };
  render() {
    const nextStepsCompleted = this.props.data?.nextSteps === null;
    return (
      <Button
        id="process"
        className="button-size"
        style={
          nextStepsCompleted
            ? { pointerEvents: "none", backgroundColor: "lightgray" }
            : { cursor: "pointer" }
        }
        onClick={() => !nextStepsCompleted && this.redirect()}
      >
        {this.props?.frameworkComponentWrapper?.agGridReact?.props
          ?.frameworkComponents?.buttonRenderer?.props !== undefined &&
        (this.props?.frameworkComponentWrapper?.agGridReact?.props
          ?.frameworkComponents?.buttonRenderer?.props?.roleName ===
          "accountsPayableAdmin" ||
          this.props?.frameworkComponentWrapper?.agGridReact?.props
            ?.frameworkComponents?.buttonRenderer?.props?.roleName ===
            "accountsPayableAuditor" ||
          this.props?.frameworkComponentWrapper?.agGridReact?.props
            ?.frameworkComponents?.buttonRenderer?.props?.roleName ===
            "expensePayableAdmin")
          ? this.props?.data?.nextSteps === "Dvn Audit"
            ? "DVN Audit"
            : "DVN Set Up"
          : "+ UPDATE STATUS"}
      </Button>
    );
  }
}

export default ButtonRenderer;
